import maActionsButtons from '@/components/button-blue'
import maAppointmentCalendar from '@/modules/Appointment/components/appointmentCalendar'
import maAppointmentHours from '@/modules/Appointment/components/appointmentHours'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import {
  apiPostSinisterScheduleContact,
  apiPostSinisterScheduleReserve,
  apiGetSinisterSchedule
} from '@/modules/Appointment/services/schedule'
import { mapMutations } from 'vuex'
import { UPDATE_LOADER } from '@/store/types'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'

export default {
  name: 'appointmentContainer',

  mixins: [flowMixin],

  data() {
    return {
      loading: false,
      selectedDate: null,
      selectedHour: {},
      schedule: {
        id: null,
        dates: null
      },
      availableDates: [],
      availableHours: [],
      hoursVisible: false,
      sinisterSchedule: null
    }
  },

  computed: {
    isHoursVisible() {
      return this.hoursVisible
    },
    primaryButtonIsDisabled() {
      return (
        !this.selectedHour.from ||
        this.selectedDate === null ||
        this.availableDates.length === 0
      )
    },
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtnWhite'
    },
    monthsArray() {
      return [
        this.$t('appointment.appointmentContainer.dates.months.january'),
        this.$t('appointment.appointmentContainer.dates.months.february'),
        this.$t('appointment.appointmentContainer.dates.months.march'),
        this.$t('appointment.appointmentContainer.dates.months.april'),
        this.$t('appointment.appointmentContainer.dates.months.may'),
        this.$t('appointment.appointmentContainer.dates.months.june'),
        this.$t('appointment.appointmentContainer.dates.months.july'),
        this.$t('appointment.appointmentContainer.dates.months.august'),
        this.$t('appointment.appointmentContainer.dates.months.september'),
        this.$t('appointment.appointmentContainer.dates.months.october'),
        this.$t('appointment.appointmentContainer.dates.months.november'),
        this.$t('appointment.appointmentContainer.dates.months.december')
      ]
    }
  },

  components: {
    maAppointmentCalendar,
    maAppointmentHours,
    maActionsButtons
  },

  methods: {
    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),

    mapAppointmentDates(sinisterScheduleDates) {
      return sinisterScheduleDates.map((range) => {
        const rangeDateArray = range.date.split('/')
        return new Date(
          rangeDateArray[2],
          rangeDateArray[1] - 1,
          rangeDateArray[0]
        )
      })
    },

    mapAppointmentHours(dateHours) {
      if (!dateHours) return []

      return dateHours.map((hour) => {
        return {
          from: hour.from,
          to: hour.to,
          text:
            hour.from && hour.to
              ? `${hour.from.slice(0, -3)} - ${hour.to.slice(0, -3)}`
              : '-'
        }
      })
    },

    async setSinisterSchedule(successCallback) {
      try {
        const { agendaResultDto: sinisterSchedule } =
          await apiGetSinisterSchedule(this.getSinisterId)

        if (!sinisterSchedule) {
          this.goToNextState(FLOW_TRANSITIONS.FINISHED_KO)
          return
        }

        this.schedule.id = sinisterSchedule.scheduleId
        this.schedule.dates = sinisterSchedule.ranges
          ? sinisterSchedule.ranges
          : []
        this.availableDates = this.mapAppointmentDates(this.schedule.dates)
        if (this.availableDates.length === 0) {
          this.goToNextState(FLOW_TRANSITIONS.FINISHED_KO)
          return
        }
        successCallback()
      } catch (e) {
        const errs = [400, 500, 409]
        const errCode =
          errs.find((errCode) => e.response && e.response.status === errCode) || 0
        if (errCode === 500) {
          this.goToNextState(FLOW_TRANSITIONS.FINISHED_ERROR)
          return
        }
        await this.sendAppointmentContact()
        this.goToNextState(FLOW_TRANSITIONS.FINISHED_ERROR)
      }
    },

    formatSelectedAppointment() {
      return `${this.selectedDate} ${this.selectedHour.from}`
    },

    formatManageDamageAppointmentFlowContactResult() {
      const selectedDateArray = this.selectedDate.split('/')
      const selectedDay = selectedDateArray[0]
        ? parseInt(selectedDateArray[0], 10)
        : '-'
      const selectedMonth = selectedDateArray[1] ? selectedDateArray[1] : '-'
      const selectedMonthLiteral = this.monthsArray[selectedMonth - 1]
      if (this.getFlowName == 'ren_soggesur'){
        return `${selectedDay}/${selectedDateArray[1]}/${selectedDateArray[2]}_${this.selectedHour.from.slice(
          0,
          -3
        )}_-_${this.selectedHour.to.slice(0, -3)}__`
      }else{
        return `${selectedDay}_${selectedMonthLiteral}_${this.selectedHour.from.slice(
          0,
          -3
        )}_-_${this.selectedHour.to.slice(0, -3)}`
      }
    },

    async reserveSinisterAppointment() {
      await apiPostSinisterScheduleReserve({
        sinisterId: this.getSinisterId,
        scheduleId: this.schedule.id,
        appointmentDate: this.formatSelectedAppointment()
      })
    },

    async sendAppointmentContact() {
      await apiPostSinisterScheduleContact(this.getSinisterId)
    },

    handleClickDate(selectedDate) {
      if (!this.schedule.dates) return
      this.selectedHour = {}

      this.hoursVisible = false
      this.selectedDate = selectedDate

      setTimeout(() => {
        const selectedDateObject = this.schedule.dates.filter((dates) => {
          return dates.date === selectedDate
        })[0]

        if (!selectedDateObject) return

        this.availableHours = this.mapAppointmentHours(selectedDateObject.hours)
        this.hoursVisible = true
      }, 250)
    },

    handleClickHour(selectedHour) {
      this.selectedHour = this.availableHours.filter((hoursObject) => {
        return hoursObject.from === selectedHour
      })[0]
    },

    async handlePrimaryButtonClick() {
      this.loading = true

      try {
        await this.reserveSinisterAppointment()

        this.goToNextState(FLOW_TRANSITIONS.FINISHED_OK, {
          date: this.formatManageDamageAppointmentFlowContactResult()
        })
      } catch (e) {
        const messageNotification = this.$t(
          'appointment.appointmentContainer.notifications.errors.postAppointment'
        )
        this.throwNotification(messageNotification, messageNotification, 'KO')
        this.loading = false
        this.goToNextState(FLOW_TRANSITIONS.FINISHED_ERROR)
      }
    },

    async handleSecondaryButtonClick() {
      this.loading = true

      try {
        await this.sendAppointmentContact()
        this.goToNextState(FLOW_TRANSITIONS.FINISHED_KO)
      } catch (e) {
        const messageNotification = this.$t(
          'appointment.appointmentContainer.notifications.errors.postContact'
        )
        this.throwNotification(messageNotification, messageNotification, 'KO')
        this.loading = false
      }
    },

    handleTertiaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.SHOW_COMPENSATION_TYPE)
    }
  },

  async mounted() {
    this.updateLoader(true)
    await this.setSinisterSchedule(() => {
      this.updateLoader(false)
    })
  }
}
